import $ from 'jquery';
import { createFocusTrap } from 'focus-trap';

const $document = $(document);
const $navigation = $('.js-navigation');
const $navigationToggle = $('.js-navigation-toggle');
const $navigationLink = $('.js-navigation-link');
const focusTrap = createFocusTrap($navigation[0]);

function toggle() {
  $navigation.toggleClass('is-toggled');
  $navigationToggle.toggleClass('is-toggled');
  if ($navigation.hasClass('is-toggled')) {
    focusTrap.activate();
  } else {
    focusTrap.deactivate();
  }
}

// Note: anchor links don't work with `body { overflow: hidden }` when the
// navigation is toggled, so we need to slightly delay the "scroll" action (via
// window.location.replace) until the overflow: hidden is removed.
$navigationLink.on('click', function (event) {
  const target = $(this).attr('href');
  if (!target || !target.includes('#')) {
    return;
  }
  event.preventDefault();
  // Close the navigation
  toggle();
  // Wait until `body { overflow: hidden }` is removed, and then scroll
  setTimeout(() => {
    window.location.replace(target);
  }, 200);
});

$navigationToggle.on('click', toggle);

$document.on('keyup', (event) => {
  if (event.key !== 'Escape') {
    return;
  }
  if ($navigation.hasClass('is-toggled')) {
    return toggle();
  }
});
